import { Expose, Type } from 'class-transformer';
import { Point } from 'geojson';

import { Default, ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { IMediaInterface } from '../interfaces';
import { IFsLprResult } from '../interfaces/common/result';

export class SnLprVigilantRead extends SnModel implements IFsLprResult {
  public plateImageSrc: string;
  public overviewImageSrc: string;

  @Expose()
  @Type(() => Date)
  public createdTimestamp: Date;

  @Expose()
  public details: any;

  @ExposeRawData()
  public geometry: Point;

  @Expose()
  public id: string;

  @Expose()
  public plate: string;

  @Expose()
  public plateImageKey: string;

  @Expose()
  public overviewImageKey: string;

  @Expose()
  public plateImageUrl: string;

  @Expose()
  public contextImageUrl: string;

  @Expose()
  public hitReason: string;

  @Expose()
  public vehicleBody: string;

  @Expose()
  public isHit: boolean;

  @Expose()
  public state: string;

  @Expose()
  public vehicleMake: string;

  public get cameraName(): string {
    return this.details?.cameraName;
  }

  public get eventTimeStamp(): Date {
    return this.details?.eventTime ? new Date(this.details?.eventTime) : null;
  }

  public get createdTimeStamp(): Date {
    return this.createdTimestamp ? new Date(this.createdTimestamp) : null;
  }

  public get displayState(): string {
    return this.state;
  }

  public get hitType(): string {
    return this.isHit ? 'hit' : 'read';
  }

  public get type(): string {
    return this.hitType;
  }

  @Expose()
  @Default('vigilant')
  public integratedLprType: string = 'vigilant';

  @Expose()
  public media: IMediaInterface[] = [];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
